import { useContext } from 'preact/hooks';
import { CompanyContext } from './companyContext';
export const useCompany = () => {
    const ctx = useContext(CompanyContext);
    if (!ctx)
        throw new Error('useCompany must be used within a CompanyProvider');
    return ctx;
};
